import { TargetModel } from '../../../modules/Apps';
import { PopoverStateReturn } from '../../common/Drawer/Drawer.context';
import { ReadOnlyFormDrawer } from '../../common/ReadOnlyFormDrawer';

import { TargetsForm } from './TargetsForm';

interface ReadOnlyTargetDrawerProps {
  state: PopoverStateReturn;
  target: TargetModel;
}

export function ReadOnlyTargetDrawer({ target, state }: ReadOnlyTargetDrawerProps) {
  return (
    <ReadOnlyFormDrawer
      initialValues={target}
      title="View Target"
      subtitle="Target properties"
      state={state}
    >
      {() => <TargetsForm appId={target.appId} readOnly />}
    </ReadOnlyFormDrawer>
  );
}
